function formatDataForTooltip({
  data,
  tooltipOptions
}) {
  const {
    keyFormatter,
    valueFormatter,
    titleFormatter
  } = {
    keyFormatter: key => `${key}`,
    valueFormatter: value => `${value}`,
    titleFormatter: title => `${title}`,
    ...tooltipOptions
  };
  const formattedData = data.data.map(data => {
    const shape = data.shape;
    const noNullData = data.data.filter(data => {
      return data.value !== null;
    });
    return {
      shape,
      data: noNullData.map(values => {
        return { ...values,
          key: keyFormatter(values.key),
          value: valueFormatter(values.value)
        };
      })
    };
  });
  return {
    formattedData,
    title: data.title ? titleFormatter(data.title) : undefined
  };
}

export { formatDataForTooltip };
